import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {setInterestZip} from './interest';
import DetailsAccessGate from './DetailsAccessGate';
import BackButton from './BackButton';
import {partyNames} from './partyFormat';

const Transaction = (transaction) => (
  <div className="transaction-container">
    <div className="transaction-body">
      <div className="transaction-grid">
        <div>
          <div className="transaction-field-label">Grantors</div>
          <div className="transaction-field-value">{partyNames(transaction, 'grantor')}</div>
        </div>
        <div>
          <div className="transaction-field-label">Grantee</div>
          <div className="transaction-field-value">{partyNames(transaction, 'grantee')}</div>
        </div>
        <div>
          <div className="transaction-field-label">Sale amount</div>
          <div className="transaction-field-value">{transaction.transferAmount}</div>
        </div>
        <div>
          <div className="transaction-field-label">Recording date</div>
          <div className="transaction-field-value">{transaction.recordingDate}</div>
        </div>
      </div>
    </div>
  </div>
);

class PropertyDetails extends Component {

  state = {
    propertyId: '',
    transactionList: ''
  };

  componentDidMount() {
    let search = new URLSearchParams(this.props.location.search);
    this.fetchData(search.get("propertyId"))
  }

  async fetchData(propertyId) {
    const response = await this.props.transactionsApi.findById(propertyId);
    if (!response.ok) {
      this.setState({
          errorMessage: `Search by name failed: ${response.status} ${response.statusText}`,
          isLoading: false
        }
      )
    } else {
      const jsonData = await response.json();
      if (jsonData.length > 0) {
        setInterestZip(jsonData[0].propertyAddressZIP);
      }
      this.setState({
        transactionList: jsonData
      });
    }
  };

  render() {
    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Property details</span>
          <h2 className="page-title">Transaction history</h2>

          <DetailsAccessGate authenticated={this.props.authenticated} subscriptionStatus={this.props.subscriptionStatus}>
            {this.state.transactionList ? (
              <div>
                {this.state.transactionList.length > 0 && (
                  <p className="page-subtitle" style={{marginBottom: 6}}>
                    Showing transaction history for{' '}
                    <b>
                      {this.state.transactionList[0].propertyAddressFull}, {this.state.transactionList[0].propertyAddressCity}, {this.state.transactionList[0].propertyAddressState} {this.state.transactionList[0].propertyAddressZIP}
                    </b>
                  </p>
                )}
                {this.state.transactionList.length > 0 ? (
                  <div className="result-list">
                    {this.state.transactionList.map((transaction, index) => (
                      <Transaction key={index} {...transaction} />
                    ))}
                  </div>
                ) : (
                  <div className="alert callout callout-neutral">No transactions found</div>
                )}
              </div>
            ) : (
              <div className="loading-row"><span className="spinner"/> Loading...</div>
            )}
          </DetailsAccessGate>
        </div>
      </div>
    );
  }
}

export default withRouter(PropertyDetails);
